import React from 'react';

export default function PeerSupport() {
  const ontarioChats = [
    {
      name: "Ontario Breast Cancer Community",
      url: "https://www.cancercareontario.ca/en/resources-patients-and-families",
      description: "Peer support for breast cancer patients in Ontario"
    },
    {
      name: "Canadian Cancer Society - Ontario",
      url: "https://cancer.ca/en/living-with-cancer/how-we-can-help/connect-with-our-online-community",
      description: "Peer support programs across Ontario"
    },
    {
      name: "Wellspring Cancer Support Network",
      url: "https://wellspring.ca/",
      description: "Support groups and peer programs in Ontario"
    },
    {
      name: "Hope & Cope",
      url: "https://www.hopeandcope.ca/",
      description: "Wellness and peer support for cancer patients"
    },
    {
      name: "Bladder Cancer Canada - Support Groups",
      url: "https://bladdercancercanada.org/en/patients/get-support/support-groups/",
      description: "Bladder Cancer Patient and Caregiver Support Groups"
    }
  ];

  const educationResources = [
    {
      name: "Canadian Cancer Society - Cancer Types",
      url: "https://cancer.ca/en",
      description: "Information about different types of cancer"
    },
    {
      name: "Ontario Health - Cancer Care",
      url: "https://www.ontariohealth.ca/clinical/cancer",
      description: "Ontario government cancer care information"
    },
    {
      name: "American Cancer Society",
      url: "https://www.cancer.org/",
      description: "Comprehensive cancer information and resources"
    },
    {
      name: "National Cancer Institute",
      url: "https://www.cancer.gov/",
      description: "Research-based cancer information"
    },
    {
      name: "Mayo Clinic - Cancer",
      url: "https://www.mayoclinic.org/diseases-conditions/cancer/symptoms-causes/syc-20370588",
      description: "Patient education on cancer types and treatments"
    }
  ];

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h2 style={{ color: '#1D9E75', marginBottom: '30px', textAlign: 'center' }}>
        Peer Support Community
      </h2>

      <div style={{ marginBottom: '40px' }}>
        <h3 style={{ color: '#374151', marginBottom: '20px' }}>
          Ontario Cancer Support Communities
        </h3>
        <p style={{ color: '#64748b', marginBottom: '20px', lineHeight: '1.6' }}>
          Connect with others going through similar experiences. These organizations provide peer support
          groups, online communities, and counseling services specifically for cancer patients in Ontario.
        </p>

        <div style={{ display: 'grid', gap: '15px' }}>
          {ontarioChats.map((chat, index) => (
            <div
              key={index}
              style={{
                background: 'linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)',
                border: '1px solid #dbeafe',
                borderRadius: '12px',
                padding: '20px',
                boxShadow: '0 4px 12px rgba(15, 23, 42, 0.08)',
              }}
            >
              <h4 style={{ margin: '0 0 8px 0', color: '#1e293b' }}>
                {chat.name}
              </h4>
              <p style={{ margin: '0 0 15px 0', color: '#64748b', fontSize: '14px' }}>
                {chat.description}
              </p>
              <a
                href={chat.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  background: '#1D9E75',
                  color: 'white',
                  padding: '8px 16px',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontSize: '14px',
                  fontWeight: '500',
                  transition: 'background-color 0.2s',
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#15803d'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#1D9E75'}
              >
                Visit Community ↗
              </a>
            </div>
          ))}
        </div>
      </div>

      <div>
        <h3 style={{ color: '#374151', marginBottom: '20px' }}>
          Patient Education Resources
        </h3>
        <p style={{ color: '#64748b', marginBottom: '20px', lineHeight: '1.6' }}>
          Learn more about your cancer type, treatment options, and self-care strategies from trusted sources.
        </p>

        <div style={{ display: 'grid', gap: '15px' }}>
          {educationResources.map((resource, index) => (
            <div
              key={index}
              style={{
                background: 'linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)',
                border: '1px solid #dbeafe',
                borderRadius: '12px',
                padding: '20px',
                boxShadow: '0 4px 12px rgba(15, 23, 42, 0.08)',
              }}
            >
              <h4 style={{ margin: '0 0 8px 0', color: '#1e293b' }}>
                {resource.name}
              </h4>
              <p style={{ margin: '0 0 15px 0', color: '#64748b', fontSize: '14px' }}>
                {resource.description}
              </p>
              <a
                href={resource.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  background: '#3b82f6',
                  color: 'white',
                  padding: '8px 16px',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  fontSize: '14px',
                  fontWeight: '500',
                  transition: 'background-color 0.2s',
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = '#2563eb'}
                onMouseOut={(e) => e.target.style.backgroundColor = '#3b82f6'}
              >
                Learn More ↗
              </a>
            </div>
          ))}
        </div>
      </div>

      <div style={{
        marginTop: '40px',
        padding: '20px',
        background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
        border: '1px solid #bae6fd',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <h4 style={{ margin: '0 0 10px 0', color: '#0c4a6e' }}>
          Need Immediate Support?
        </h4>
        <p style={{ margin: '0 0 15px 0', color: '#64748b', fontSize: '14px' }}>
          If you're experiencing a medical emergency or need urgent care, please contact your healthcare provider or emergency services immediately.
        </p>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <a
            href="tel:911"
            style={{
              background: '#dc2626',
              color: 'white',
              padding: '10px 20px',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
            }}
          >
            Emergency: 911
          </a>
          <a
            href="tel:211"
            style={{
              background: '#1D9E75',
              color: 'white',
              padding: '10px 20px',
              borderRadius: '8px',
              textDecoration: 'none',
              fontWeight: '600',
            }}
          >
            Crisis Support: 211
          </a>
        </div>
      </div>
    </div>
  );
}